// Interfaces
import { IBaseTableHeaderRightProps } from './interfaces'

const BaseTableHeaderRight = ({ children, ...rest }: IBaseTableHeaderRightProps) => {
  return (
    <div className="flex flex-col md:flex-row justify-end" {...rest}>
      {children}
    </div>
  )
}

export { BaseTableHeaderRight }
